import { Inject, Injectable } from "@angular/core";
import {
    NmsAutoUpdaterManagerService
} from "@nms-ng2/app/shared/components/elements/nms-auto-updater/nms-auto-updater-manager.service";
import {
    NmsAutoUpdaterRegistryService
} from "@nms-ng2/app/shared/components/elements/nms-auto-updater/nms-auto-updater-registry.service";
import { RefreshIntervalService } from "@nms-ng2/app/shared/services/refresh-interval/refresh-interval.service";
import {
    ANGULARJS_TRANSLATE,
    DEVICE_POLLING_REST_SERVICE
} from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { of } from "rxjs";

/**
 * Gerencia o auto-updater da tela de Info/Config.
 */
@Injectable({
    providedIn: "root"
})
export class InfoConfigAutoUpdateManagerService extends NmsAutoUpdaterManagerService {

    constructor(@Inject(DEVICE_POLLING_REST_SERVICE) readonly devicePollingRestService: any,
            readonly refreshInterval: RefreshIntervalService,
            @Inject(ANGULARJS_TRANSLATE) private readonly translate: any,
            private readonly registryService: NmsAutoUpdaterRegistryService) {
        super(devicePollingRestService, refreshInterval);
    }

    resolveDeviceId(deviceId: number) {
        return of(deviceId);
    }

    pause(id: string) {
        const autoUpdaterComponent = this.registryService.retrieve(id);
        autoUpdaterComponent.pause();
        autoUpdaterComponent.customPausedMessage = this.translate.instant("yang.config.change.readonly.not.updatable");
    }
}
